import React, { useState, useEffect } from 'react';
import { 
    Card, CardBody, CardFooter, CardHeader, Col, Input, Modal,
    ModalHeader, ModalBody, ModalFooter, Row, Form, FormGroup, 
    Button, Table, Label 
} from 'reactstrap';
import Select from "react-select";
import * as moment from "moment";
import { FileUploader } from "react-drag-drop-files";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { api } from "../../../config";
import { jsPDF } from "jspdf";
import logo from '../../../assets/images/logos/logo_preta.jpeg';
import { fetchComAuth, fetchComAuthJson } from '../../../common/api';

const CadastroExpositor = ({ id, feiraId, onClose }) => {
    
    const [paises, setPaises] = useState([]);
    const [pais, setPais] = useState([]);
    const [isBrasil, setIsBrasil] = useState(false);
    const [isEditando, setIsEditando] = useState(false);
    const [logoFile, setLogoFile] = useState(null);
    const [logoUrl, setLogoUrl] = useState(null);
    const [ativo, setAtivo] = useState(false);
    const [aprovado, setAprovado] = useState(false);
    const [modalArquivos, setModalArquivos] = useState(false);
    const [files, setFiles] = useState([]);
    const [observacaoArquivos, setObservacaoArquivos] = useState("");
    const [loadingArquivos, setLoadingArquivos] = useState(false);
    const [arquivosSalvos, setArquivosSalvos] = useState([]);
    const [modalDelete, setModalDelete] = useState(false);
    const [arquivoExcluir, setArquivoExcluir] = useState(null);
    const [expositor, setExpositor] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [selectedSetores, setSelectedSetores] = useState([]);
    const [selectedAreasInteresse, setSelectedAreasInteresse] = useState([]);
    const [selectedCategorias, setSelectedCategorias] = useState([]);

    const [setoresOpcoes, setSetoresOpcoes] = useState([]);
    const [categoriasOpcoes, setCategoriasOpcoes] = useState([]);
    const [areasInteresseOpcoes, setAreasInteresseOpcoes] = useState([]);

    const [formData, setFormData] = useState({
        nome: '',
        nome_fantasia: '',
        nome_mapa: '',
        cnpj_codigo_internacional: '',
        responsavel: '',
        email: '',
        email_financeiro: '',
        email_estande: '',
        email_cobranca: '',
        email_contrato: '',
        email_renovacao: '',
        telefone: '',
        fax: '',
        celular: '',
        inscricao_estadual: '',
        whatsapp: '',
        pais: '',
        cep: '',
        estado: '',
        cidade: '',
        bairro: '',
        endereco: '',
        numero: '',
        complemento: '',
        instagram: '',
        twitter: '',
        linkedin: '',
        youtube: '',
        facebook: '',
        bluesky: '', // site
        imagens: [], 
        descricao: '',
        descricao_produtos_servicos: ''
    });

    useEffect(() => {
        const carregarPaises = async () => {
            try {
            const response = await fetch(`${api.API_URL}/paises`, {
                headers: { chave: "18266602-6085-4532-992d-7bc2750b19f4" }
            });
            const paises = await response.json();
            setPaises(paises.data);
            
            } catch (error) {
            console.error("Erro ao carregar o JSON:", error);
            }
        };

        carregarPaises();
    }, [feiraId]);

    useEffect(() => {
    setIsBrasil(pais === "BR");
    }, [pais]);
        
    const toggleModalDelete = () => setModalDelete(!modalDelete);

    const confirmarExclusao = (id) => {
        setArquivoExcluir(id);
        setModalDelete(true);
    };

    const handleEnviarArquivos = async () => {
        try {
            setLoadingArquivos(true);
            
            const data = new FormData();
            const filesArray = files instanceof FileList ? 
                Array.from(files) : 
                (Array.isArray(files) ? files : []);

            filesArray.forEach(file => {
                data.append('arquivos', file);
            });
            
            data.append('expositor_id', id);
            data.append('observacao', observacaoArquivos);

            const response = await fetchComAuthJson(`${api.API_URL}/expositor/arquivos/${id}`, {
                method: 'POST',
                body: data
            });

            if (response.status) {
                toast.success("Arquivos enviados com sucesso!");
                setModalArquivos(false);
                setFiles([]);
                setObservacaoArquivos("");
                // Opcional: recarregar os arquivos do expositor
            } else {
                throw new Error(response.data.message || "Falha ao enviar arquivos");
            }
        } catch (err) {
            toast.error(err.message || "Erro ao enviar arquivos");
        } finally {
            setLoadingArquivos(false);
        }
    };

    const handleExcluirArquivo = async (arquivoId) => {
        try {
            const response = await fetchComAuth(`${api.API_URL}/expositor/excluirArquivo/${arquivoId}`, {
                method: 'DELETE',
            });

            if (response.ok) {
                toast.success("Arquivo excluído com sucesso!");
                setModalDelete(false);
                setArquivosSalvos(prev => prev.filter(arq => arq.id !== arquivoId));
            } else {
                throw new Error('Falha ao excluir arquivo');
            }
        } catch (err) {
            console.error('Erro ao excluir arquivo:', err);
            toast.error(err.message || "Erro ao excluir arquivo");
        }
    };
    
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const maxSize = 2 * 1024 * 1024; // 2MB
        const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
        
        if (file) {
            if (!allowedTypes.includes(file.type)) {
                toast.error('Formato inválido. Use apenas JPEG, PNG ou GIF');
                e.target.value = '';
                return;
            }
            
            if (file.size > maxSize) {
                toast.error(`Arquivo muito grande (${(file.size / (1024*1024)).toFixed(2)}MB). O máximo permitido é 2MB.`);
                e.target.value = '';
                return;
            }
            
            setLogoFile(file);
            setLogoUrl(URL.createObjectURL(file));
        }
    };

    const handleImagensChange = (e) => {
        const files = Array.from(e.target.files);
        const newImages = files.map(file => ({
            file, // Guarda a referência do File original para upload
            preview: URL.createObjectURL(file) // Cria preview
        }));
        
        setFormData(prev => ({
            ...prev,
            imagens: [...prev.imagens, ...newImages]
        }));

        e.target.value = null; 
    }

    const removeImagemProduto = (index) => {
        const img = formData.imagens[index];
        
        // Revoga o URL do objeto para liberar memória
        if (img.preview) {
            URL.revokeObjectURL(img.preview);
        }
            
        setFormData(prev => ({
            ...prev,
            imagens: prev.imagens.filter((_, i) => i !== index)
        }));
    };

    const handleValidDate = date => {
        return moment(new Date(date)).format("DD/MM/YYYY");
    };

    const buscarCep = async (cep) => {
        const cepLimpo = cep.replace(/\D/g, '');
        if (cepLimpo.length !== 8) return;

        try {
            const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
            const data = await response.json();
            
            if (!data.erro) {
                
                setFormData(prevState => ({
                    ...prevState,
                    endereco: data.logradouro,
                    bairro: data.bairro,
                    cidade: data.localidade,
                    estado: data.uf,
                   // pais: data.pais,
                    complemento: data.complemento || prevState.complemento
                }));
            } else {
                toast.error("CEP não encontrado");
            }
        } catch (error) {
            console.error("Erro ao buscar CEP:", error);
            toast.error("Erro ao buscar CEP.");
        }
    };

    const handleExportPDF = async () => {
        try {
        // Criar novo documento PDF
        const doc = new jsPDF({
            unit: 'mm',
            format: 'a4',
            compress: true
        });

        // Configurações
        const margin = 15;
        const pageWidth = doc.internal.pageSize.getWidth();
        const availableWidth = pageWidth - (2 * margin);
        
        // Cores
        const primaryColor = [54, 54, 54 ];
        const secondaryColor = [79, 79, 79];

        // Estilos
        const setHeaderStyle = () => {
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(...primaryColor);
        };

        const setBodyStyle = () => {
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(...secondaryColor);
        };

        // --- CABEÇALHO ---
        setHeaderStyle();
        doc.setFontSize(16);
        doc.text(`Relatório Expositor - ${expositor.nome.toUpperCase()}`, pageWidth / 2, 20, { align: 'center' });
        
        // Linha divisória
        doc.setDrawColor(...primaryColor);
        doc.setLineWidth(0.5);
        doc.line(margin, 25, pageWidth - margin, 25);

        // --- INFORMAÇÕES PRINCIPAIS ---
        let yPosition = 30;

        setHeaderStyle();
        doc.setFontSize(12);
        doc.text('INFORMAÇÕES PRINCIPAIS', margin, yPosition);
        yPosition += 7; // Aumentei o espaçamento após o título

        setBodyStyle();
        doc.setFontSize(10);
        
        // Função para adicionar linha de informação com alinhamento correto
        const addInfoLine = (label, value, y) => {
            const labelWidth = 50; // Largura fixa para os labels
            const valueX = margin + labelWidth + 5;
            
            // Escreve o label
            doc.setFont('helvetica', 'bold');
            doc.text(`${label}:`, margin, y);
            
            // Escreve o valor com quebra de linha se necessário
            doc.setFont('helvetica', 'normal');
            const lines = doc.splitTextToSize(value || 'N/A', availableWidth - labelWidth - 5);
            
            // Verifica se o valor tem múltiplas linhas
            if (lines.length > 1) {
            doc.text(lines, valueX, y);
            return y + (lines.length * 5); // Ajusta a posição Y baseado no número de linhas
            } else {
            doc.text(lines[0], valueX, y);
            return y + 5; // Espaçamento padrão para linha única
            }
        };

        yPosition = addInfoLine('Nome Fantasia', expositor.nome_fantasia, yPosition);
        yPosition = addInfoLine('CNPJ/Código Internacional', expositor.cnpj_codigo_internacional, yPosition);
        yPosition = addInfoLine('Responsável', expositor.responsavel, yPosition);
        yPosition = addInfoLine('Telefone', expositor.telefone, yPosition);
        yPosition = addInfoLine('E-mail', expositor.email, yPosition);
        yPosition += 5; // Espaço extra entre seções

        // --- ENDEREÇO ---
        setHeaderStyle();
        doc.text('ENDEREÇO', margin, yPosition);
        yPosition += 7;

        setBodyStyle();
        const enderecoCompleto = [
            expositor.endereco,
            expositor.numero && `Nº ${expositor.numero}`,
            expositor.complemento,
            expositor.bairro,
            `${expositor.cidade || ''}${expositor.estado ? `/${expositor.estado}` : ''}`,
            expositor.cep
        ].filter(Boolean).join(', ');

        yPosition = addInfoLine('Endereço', enderecoCompleto || 'Não informado', yPosition);
        yPosition += 5; // Espaço extra entre seções

        // --- CONTATOS ADICIONAIS ---
        setHeaderStyle();
        doc.text('CONTATOS ADICIONAIS', margin, yPosition);
        yPosition += 7;

        setBodyStyle();
        yPosition = addInfoLine('Celular', expositor.celular, yPosition);
        yPosition = addInfoLine('WhatsApp', expositor.whatsapp, yPosition);
        yPosition = addInfoLine('E-mail de Cobrança', expositor.email_cobranca, yPosition);
        yPosition = addInfoLine('E-mail Financeiro', expositor.email_financeiro, yPosition);
        yPosition += 5;

        // --- REDES SOCIAIS ---
        setHeaderStyle();
        doc.text('REDES SOCIAIS', margin, yPosition);
        yPosition += 7;

        setBodyStyle();
        const redesSociais = [
            expositor.instagram && `Instagram: ${expositor.instagram}`,
            expositor.facebook && `Facebook: ${expositor.facebook}`,
            expositor.linkedin && `LinkedIn: ${expositor.linkedin}`,
            expositor.twitter && `Twitter: ${expositor.twitter}`,
            expositor.youtube && `YouTube: ${expositor.youtube}`,
            expositor.tiktok && `TikTok: ${expositor.tiktok}`
        ].filter(Boolean);

        if (redesSociais.length > 0) {
            redesSociais.forEach(rede => {
            doc.text(`• ${rede}`, margin + 5, yPosition);
            yPosition += 5;
            });
        } else {
            doc.text('Nenhuma rede social informada', margin + 5, yPosition);
            yPosition += 5;
        }
        yPosition += 3;

        // --- INFORMAÇÕES ADICIONAIS ---
        setHeaderStyle();
        doc.text('INFORMAÇÕES ADICIONAIS', margin, yPosition);
        yPosition += 7;

        setBodyStyle();
        yPosition = addInfoLine('Inscrição Estadual', expositor.inscricao_estadual, yPosition);
        yPosition = addInfoLine('Status', expositor.ativo ? 'Ativo' : 'Inativo', yPosition);
        yPosition = addInfoLine('Aprovado', expositor.aprovado ? 'Sim' : 'Não', yPosition);
        yPosition = addInfoLine('Data de Cadastro', moment(expositor.created_at).format('DD/MM/YYYY HH:mm'), yPosition);
        yPosition = addInfoLine('Última Atualização', moment(expositor.updated_at).format('DD/MM/YYYY HH:mm'), yPosition);

        // --- RODAPÉ COM LOGO DE ASSETS ---
        doc.setFontSize(8);
        doc.setTextColor(100);
        
        // Data à esquerda
        doc.text(`Gerado em ${moment().format('DD/MM/YYYY HH:mm')}`, margin, 285, { align: 'left' });
        
        // Logo no centro - do diretório assets
        try {
            // Dimensões da logo (ajuste conforme necessário)
            const logoWidth = 20;
            const logoHeight = 8;
            const logoX = (pageWidth - logoWidth) / 2;
            
            // Adiciona a logo
            const img = new Image();
            img.src = logo;
            
            await new Promise((resolve) => {
            img.onload = () => {
                doc.addImage(img, 'PNG', logoX, 280, logoWidth, logoHeight);
                resolve();
            };
            img.onerror = () => resolve();
            });
        } catch (e) {
            console.log('Erro ao carregar logo:', e);
            doc.setFontSize(10);
            doc.text('Meu Sistema', pageWidth / 2, 284, { align: 'center' });
        }
        
        // Número da página à direita
        doc.text(`Página ${doc.internal.getNumberOfPages()}`, pageWidth - margin, 285, { align: 'right' });

        // Salvar PDF
        doc.save(`Dados_Cadastrais_${expositor.nome}_${moment().format('YYYYMMDD_HHmm')}.pdf`);
        toast.success('PDF exportado com sucesso!');
        } catch (error) {
        console.error('Erro ao gerar PDF:', error);
        toast.error('Falha ao exportar PDF');
        }
    };

   const handleExportCSV = () => {
        try {
            if (!expositor) {
            toast.error("Nenhum dado disponível para exportar");
            return;
            }

            // Preparar os dados em formato de colunas
            const data = {
            "Nome": expositor.nome,
            "Nome Fantasia": expositor.nome_fantasia,
            "Nome no Mapa": expositor.nome_mapa,
            "CNPJ/Código Internacional": expositor.cnpj_codigo_internacional,
            "Inscrição Estadual": expositor.inscricao_estadual,
            "Responsável": expositor.responsavel,
            "Telefone": expositor.telefone,
            "Celular": expositor.celular,
            "WhatsApp": expositor.whatsapp,
            "Fax": expositor.fax,
            "E-mail": expositor.email,
            "E-mail Financeiro": expositor.email_financeiro,
            "E-mail Cobrança": expositor.email_cobranca,
            "E-mail Contrato": expositor.email_contrato,
            "E-mail marketing": expositor.email_estande,
            "E-mail Renovação": expositor.email_renovacao,
            "Endereço": expositor.endereco,
            "Número": expositor.numero,
            "Complemento": expositor.complemento,
            "Bairro": expositor.bairro,
            "Cidade": expositor.cidade,
            "Estado": expositor.estado,
            "CEP": expositor.cep,
            "Instagram": expositor.instagram,
            "Twitter": expositor.twitter,
            "LinkedIn": expositor.linkedin,
            "YouTube": expositor.youtube,
            "Facebook": expositor.facebook,
            "Site": expositor.bluesky,
            "Status": expositor.ativo ? "Ativo" : "Inativo",
            "Aprovado": expositor.aprovado ? "Sim" : "Não",
            "Data de Cadastro": moment(expositor.created_at).format('DD/MM/YYYY HH:mm'),
            "Última Atualização": moment(expositor.updated_at).format('DD/MM/YYYY HH:mm')
            };

            // Cabeçalhos (nomes das colunas)
            const headers = Object.keys(data);
            
            // Valores (linha de dados)
            const values = headers.map(header => {
            const value = data[header] || '';
            // Escapa valores que contêm vírgulas ou aspas
            return typeof value === 'string' && (value.includes(',') || value.includes('"')) 
                ? `"${value.replace(/"/g, '""')}"` 
                : value;
            });

            // Cria conteúdo CSV
            const csvContent = [
            headers.join(';'),  // Linha de cabeçalho
            values.join(';')    // Linha de valores
            ].join('\n');

            // Cria blob e faz download
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            
            link.setAttribute('href', url);
            link.setAttribute('download', `Dados_Cadastrais_${expositor.nome}_${moment().format('YYYYMMDD_HHmm')}.csv`);
            link.style.visibility = 'hidden';
            
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            toast.success('CSV exportado com sucesso!');
        } catch (error) {
            console.error('Erro ao exportar CSV:', error);
            toast.error('Falha ao exportar CSV');
        }
    };

    const handleExportXML = () => {
        try {
            if (!expositor) {
            toast.error("Nenhum dado disponível para exportar");
            return;
            }

            // Função auxiliar para escapar caracteres XML
            const escapeXml = (unsafe) => {
            if (unsafe === null || unsafe === undefined) return '';
            return unsafe.toString()
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&apos;');
            };

            // Cria estrutura XML
            let xmlContent = '<?xml version="1.0" encoding="UTF-8"?>\n';
            xmlContent += `<Expositor>\n`;
            xmlContent += `  <Nome>${escapeXml(expositor.nome)}</Nome>\n`;
            xmlContent += `  <NomeFantasia>${escapeXml(expositor.nome_fantasia)}</NomeFantasia>\n`;
            xmlContent += `  <CNPJCodigoInternacional>${escapeXml(expositor.cnpj_codigo_internacional)}</CNPJCodigoInternacional>\n`;
            xmlContent += `  <Responsavel>${escapeXml(expositor.responsavel)}</Responsavel>\n`;
            xmlContent += `  <Telefone>${escapeXml(expositor.telefone)}</Telefone>\n`;
            xmlContent += `  <Email>${escapeXml(expositor.email)}</Email>\n`;
            xmlContent += `  <Celular>${escapeXml(expositor.celular)}</Celular>\n`;
            xmlContent += `  <WhatsApp>${escapeXml(expositor.whatsapp)}</WhatsApp>\n`;
            xmlContent += `  <Endereco>\n`;
            xmlContent += `    <Logradouro>${escapeXml(expositor.endereco)}</Logradouro>\n`;
            xmlContent += `    <Numero>${escapeXml(expositor.numero)}</Numero>\n`;
            xmlContent += `    <Complemento>${escapeXml(expositor.complemento)}</Complemento>\n`;
            xmlContent += `    <Bairro>${escapeXml(expositor.bairro)}</Bairro>\n`;
            xmlContent += `    <Cidade>${escapeXml(expositor.cidade)}</Cidade>\n`;
            xmlContent += `    <Estado>${escapeXml(expositor.estado)}</Estado>\n`;
            xmlContent += `    <CEP>${escapeXml(expositor.cep)}</CEP>\n`;
            xmlContent += `  </Endereco>\n`;
            xmlContent += `  <InscricaoEstadual>${escapeXml(expositor.inscricao_estadual)}</InscricaoEstadual>\n`;
            xmlContent += `  <Status>${expositor.ativo ? "Ativo" : "Inativo"}</Status>\n`;
            xmlContent += `  <Aprovado>${expositor.aprovado ? "Sim" : "Não"}</Aprovado>\n`;
            xmlContent += `  <DataCadastro>${moment(expositor.created_at).format('DD/MM/YYYY HH:mm')}</DataCadastro>\n`;
            xmlContent += `  <UltimaAtualizacao>${moment(expositor.updated_at).format('DD/MM/YYYY HH:mm')}</UltimaAtualizacao>\n`;
            xmlContent += `</Expositor>`;

            // Cria blob e faz download
            const blob = new Blob([xmlContent], { type: 'application/xml;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            
            link.setAttribute('href', url);
            link.setAttribute('download', `Dados_Cadastrais_${expositor.nome}_${moment().format('YYYYMMDD_HHmm')}.xml`);
            link.style.visibility = 'hidden';
            
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            toast.success('XML exportado com sucesso!');
        } catch (error) {
            console.error('Erro ao exportar XML:', error);
            toast.error('Falha ao exportar XML');
        }
    };

    const removeImage = () => {
        if (logoUrl) URL.revokeObjectURL(logoUrl);
        setLogoUrl(null);
        setLogoFile(null);
    };
    
    const handleChange = (e) => {
        const { id, value } = e.target;
        const key = id.replace('-input', '');
        
        if (key === 'pais') {
            setIsBrasil(value === "BR");
            setPais(value);
        }

        setFormData(prevState => ({
            ...prevState,
            [key]: value
        }));
    };

    useEffect(() => {
        const carregarDadosIniciais = async () => {
            try {
                setLoading(true);

                // 1. Chamadas Globais: Sempre carrega as opções dos Selects
                const [setoresRes, categoriasRes] = await Promise.all([
                    fetchComAuthJson(`${api.API_URL}/setor/${feiraId}`),
                    fetchComAuthJson(`${api.API_URL}/categoria/${feiraId}`),
                    // fetchComAuthJson(`${api.API_URL}/area-interesse/${feiraId}`)
                ]);

                // Armazena as opções brutas para uso posterior na filtragem
                const listaSetores = await setoresRes.json();
                const listaCategorias = await categoriasRes.json();
                // const listaAreas = await areasRes.json();

                // Popula as opções dos componentes Select
                setSetoresOpcoes(listaSetores.data.map(f => ({ value: f.id, label: f.nome })));
                setCategoriasOpcoes(listaCategorias.data.map(f => ({ value: f.id, label: f.nome })));
                // setAreasInteresseOpcoes(listaAreas.data.map(f => ({ value: f.id, label: f.nome })));

                // 2. Carga de Dados do Expositor (Apenas se houver ID)
                if (id) {
                    const result= await fetchComAuthJson(`${api.API_URL}/expositor/${id}`);
                    const resultExpositor  = await result.json();

                    if (resultExpositor && resultExpositor.data) {
                        const data = resultExpositor.data;
                
                        setExpositor(data);
                        setIsEditando(true);
                        
                        setFormData({
                            nome: data.nome || '',
                            nome_fantasia: data.nome_fantasia || '',
                            nome_mapa: data.nome_mapa || '',
                            cnpj_codigo_internacional: data.cnpj_codigo_internacional || '',
                            responsavel: data.responsavel || '',
                            email: data.email || '',
                            email_financeiro: data.email_financeiro || '',
                            email_estande: data.email_estande || '',
                            email_cobranca: data.email_cobranca || '',
                            email_contrato: data.email_contrato || '',
                            email_renovacao: data.email_renovacao || '',
                            telefone: data.telefone || '',
                            fax: data.fax || '',
                            celular: data.celular || '',
                            inscricao_estadual: data.inscricao_estadual || '',
                            whatsapp: data.whatsapp || '',
                            cep: data.cep || '',
                            estado: data.estado || '',
                            cidade: data.cidade || '',
                            bairro: data.bairro || '',
                            endereco: data.endereco || '',
                            pais: data.pais || '',
                            numero: data.numero || '',
                            complemento: data.complemento || '',
                            instagram: data.instagram || '',
                            twitter: data.twitter || '',
                            linkedin: data.linkedin || '',
                            youtube: data.youtube || '',
                            facebook: data.facebook || '',
                            bluesky: data.bluesky || '',
                            descricao: data.descricao || '',
                            descricao_produtos_servicos: data.descricao_produtos_servicos || '', 
                            imagens: data.imagens?.map(img => ({ url: img.url, id: img.id })) || [],
                        });
                        
                        setPais(data.pais);
                        setAtivo(data.ativo);
                        setAprovado(data.aprovado);
                        setLogoUrl(data.logoUrl || null);
                        setArquivosSalvos(data.arquivos || []);

                        // 3. Mapeia os valores selecionados usando as listas carregadas no passo 1
                        setSelectedSetores(listaSetores.data
                            .filter(s => data.setor?.some(sg => sg.setor_id === s.id))
                            .map(s => ({ value: s.id, label: s.nome }))
                        );
                    
                        setSelectedCategorias(listaCategorias.data
                            .filter(c => data.categoria?.some(cg => cg.categoria_id === c.id))
                            .map(c => ({ value: c.id, label: c.nome }))
                        );

                        // setSelectedAreasInteresse(listaAreas.data
                        //     .filter(a => data.area_interesse?.some(ag => ag.area_interesse_id === a.id))
                        //     .map(a => ({ value: a.id, label: a.nome }))
                        // );
                    }
                } else {
                    // Se for Novo Expositor, garante que os estados estejam limpos
                    setIsEditando(false);
                    setSelectedSetores([]);
                    setSelectedCategorias([]);
                    // setSelectedAreasInteresse([]);
                }

                setLoading(false);
            } catch (err) {
                setLoading(false);
                console.error("Erro ao carregar dados iniciais:", err);
                toast.error("Erro ao carregar opções de cadastro.");
            }
        };
        
        if (feiraId) {
            carregarDadosIniciais();
        }
    }, [id, feiraId]);

    const salvar = async () => {
        const metodo = id ? "PUT" : "POST";
        
        const urlSalvar = id
            ? `${api.API_URL}/expositor/${id}`
            : `${api.API_URL}/expositor`;

        if (!formData.nome) {
            toast.error("O campo 'Nome' é obrigatório.");
            return;
        }

        if (isBrasil) {
            if (!formData.cep || !formData.endereco || !formData.cidade || !formData.estado) {
                toast.error("Para o Brasil, os campos de endereço (CEP, Rua, Cidade e Estado) são obrigatórios.");
                return;
            }
        }
    
        try {
            const dataToSend = new FormData();
            const camposEnderecoBR = ['cep', 'endereco', 'bairro', 'cidade', 'estado', 'numero', 'complemento'];

            for (const key in formData) {
                if (key !== 'imagens') {
                    dataToSend.append(key, formData[key]);
                }
            }
            
            dataToSend.append("aprovado", aprovado);
            dataToSend.append("ativo", ativo);
            dataToSend.append("feira_id", feiraId);
            if (id) dataToSend.append("id", id);
            
            if (logoFile) {
                dataToSend.append("logo", logoFile);
            }

            const imagensManterIds = [];

            formData.imagens.forEach((imagem) => {
                if (imagem.file) {
                    // Se for um arquivo novo, anexe ao campo 'imagens'
                    dataToSend.append('imagens', imagem.file);
                } else if (imagem.id) {
                    // Se for uma imagem existente, guarde o ID dela
                    imagensManterIds.push(imagem.id);
                }
            });

            dataToSend.append('imagens_a_manter_ids', imagensManterIds.join(','));
            dataToSend.append('setores_ids', selectedSetores.map(s => s.value));
            dataToSend.append('categorias_ids', selectedCategorias.map(c => c.value));
            
            const response = await fetchComAuth(urlSalvar, {
                method: metodo,
                body: dataToSend, 
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Erro ao salvar o expositor.');
            }
    
            toast.success("Expositor salvo com sucesso!");
    
            setTimeout(() => {
                onClose?.();
            }, 1000);
        } catch (err) {
            console.error("Erro ao salvar expositor:", err);
            toast.error(err.message || "Erro ao salvar os dados do expositor!");
        }
    };
    
    document.title="Cadastro de Expositor | EVOMAP - Tecnologia que conecta negócios";

    if (loading) {
        return <p>Carregando opções...</p>;
    }

    if (error) {
        return <p style={{ color: 'red' }}>Erro: {error}</p>;
    }

    return (
        <React.Fragment>
            <ToastContainer closeButton={false} />
    
            <Row>
                <Col lg={12}>
                    <Card>
                        <CardHeader>
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <button
                                        type="button"
                                        className="btn btn-success w-sm"
                                        onClick={salvar}
                                    >
                                        Salvar
                                    </button>{" "}
                                    <button
                                        type="button"
                                        onClick={() => setModalArquivos(true)}
                                        className="btn btn-info w-sm"
                                    >
                                        <i className="ri-attachment-line align-middle me-1"></i>
                                        Enviar Arquivos
                                    </button>{" "}
                                    <div className="btn-group">
                                        <button 
                                            type="button"
                                            onClick={handleExportPDF}
                                            className="btn btn-warning w-sm"
                                        >
                                            <i className="ri-file-pdf-line align-bottom me-1"></i> PDF
                                        </button>
                                        <button 
                                            type="button"
                                            onClick={handleExportCSV}
                                            className="btn btn-success w-sm"
                                        >
                                            <i className="ri-file-excel-line align-bottom me-1"></i> CSV
                                        </button>
                                        <button 
                                            type="button"
                                            onClick={handleExportXML}
                                            className="btn btn-primary w-sm"
                                        >
                                            <i className="ri-code-line align-bottom me-1"></i> XML
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </CardHeader>
                        
                        <CardBody>
                            <h5 className="mb-3">Informações Básicas</h5>
                            <Row>
                                <Col lg={4}>
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="nome-input">Nome*</Label>
                                        <Input type="text" className="form-control" id="nome-input"
                                            placeholder="Nome completo do expositor" 
                                            value={formData.nome}
                                            onChange={handleChange}/>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="nome_fantasia-input">Nome Fantasia</Label>
                                        <Input type="text" className="form-control" id="nome_fantasia-input"
                                            placeholder="Nome fantasia do expositor" 
                                            value={formData.nome_fantasia}
                                            onChange={handleChange}/>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="nome_mapa-input">Nome no Mapa</Label>
                                        <Input type="text" className="form-control" id="nome_mapa-input"
                                            placeholder="Nome como aparecerá no mapa" 
                                            value={formData.nome_mapa}
                                            onChange={handleChange}/>
                                    </div>
                                </Col>
                            </Row>
                            
                            <Row>
                                <Col lg={4}>
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="cnpj_codigo_internacional-input">CNPJ/Código Internacional</Label>
                                        <Input type="text" className="form-control" id="cnpj_codigo_internacional-input"
                                            placeholder="CNPJ ou código internacional" 
                                            value={formData.cnpj_codigo_internacional}
                                            onChange={handleChange}/>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="inscricao_estadual-input">Inscrição Estadual</Label>
                                        <Input type="text" className="form-control" id="inscricao_estadual-input"
                                            placeholder="Inscrição estadual" 
                                            value={formData.inscricao_estadual}
                                            onChange={handleChange}/>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="mb-3">
                                        <Label className="form-label">Logo</Label>
                                        {!logoUrl ? (
                                            <Input
                                                className="form-control"
                                                id="expositor_logo-img"
                                                type="file"
                                                accept="image/png, image/gif, image/jpeg"
                                                onChange={handleFileChange}
                                            />
                                        ) : (
                                            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
                                                <div style={{ position: "relative" }}>
                                                    <img src={logoUrl} alt="Logo" style={{ width: "80px", height: "80px", objectFit: "cover", borderRadius: "4px" }} />
                                                    <button type="button" onClick={removeImage} style={{ position: "absolute", top: "-8px", right: "-8px", background: "#ff4444", color: "white", border: "none", borderRadius: "50%", cursor: "pointer" }}>
                                                        <i className="ri-close-fill align-bottom" />
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg={12}>
                                    <div className="mb-3">
                                        <Label className="form-label">Breve Descrição</Label>
                                        <textarea
                                            className="form-control"
                                            id="descricao-input"
                                            rows="6"
                                            defaultValue=""
                                            value={formData.descricao}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg={12}>
                                    <div className="mb-3">
                                        <Label className="form-label">Descrição Produtos e Serviços</Label>
                                        <textarea
                                            className="form-control"
                                            id="descricao_produtos_servicos-input"
                                            rows="6"
                                            defaultValue=""
                                            maxLength={255} 
                                            value={formData.descricao_produtos_servicos}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>
                                </Col>
                            </Row>

                            <h5 className="mb-3 mt-4">Contatos</h5>
                            <Row>
                                <Col lg={6}>
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="responsavel-input">Responsável</Label>
                                        <Input type="text" className="form-control" id="responsavel-input" placeholder="Nome do responsável" value={formData.responsavel} onChange={handleChange}/>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={3}>
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="telefone-input">Telefone Principal</Label>
                                        <Input type="text" className="form-control" id="telefone-input" placeholder="Telefone principal" value={formData.telefone} onChange={handleChange}/>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="whatsapp-input">WhatsApp</Label>
                                        <Input type="text" className="form-control" id="whatsapp-input" placeholder="Número do WhatsApp" value={formData.whatsapp} onChange={handleChange}/>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="celular-input">Celular</Label>
                                        <Input type="text" className="form-control" id="celular-input" placeholder="Número do celular" value={formData.celular} onChange={handleChange} />
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="fax-input">Fax</Label>
                                        <Input type="text" className="form-control" id="fax-input" placeholder="Número do fax" value={formData.fax} onChange={handleChange}/>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={3}><div className="mb-3"><Label className="form-label" htmlFor="email-input">E-mail Principal</Label><Input type="email" className="form-control" id="email-input" placeholder="E-mail principal" value={formData.email} onChange={handleChange}/></div></Col>
                                <Col lg={3}><div className="mb-3"><Label className="form-label" htmlFor="email_financeiro-input">E-mail Financeiro</Label><Input type="email" className="form-control" id="email_financeiro-input" placeholder="E-mail do financeiro" value={formData.email_financeiro} onChange={handleChange}/></div></Col>
                                <Col lg={3}><div className="mb-3"><Label className="form-label" htmlFor="email_cobranca-input">E-mail Cobrança</Label><Input type="email" className="form-control" id="email_cobranca-input" placeholder="E-mail para cobrança" value={formData.email_cobranca} onChange={handleChange}/></div></Col>
                                <Col lg={3}><div className="mb-3"><Label className="form-label" htmlFor="email_contrato-input">E-mail Contratos</Label><Input type="email" className="form-control" id="email_contrato-input" placeholder="E-mail para contratos" value={formData.email_contrato} onChange={handleChange}/></div></Col>
                            </Row>
                            <Row>
                                <Col lg={3}><div className="mb-3"><Label className="form-label" htmlFor="email_estande-input">E-mail Marketing</Label><Input type="email" className="form-control" id="email_estande-input" placeholder="E-mail do marketing" value={formData.email_estande} onChange={handleChange}/></div></Col>
                                <Col lg={3}><div className="mb-3"><Label className="form-label" htmlFor="email_renovacao-input">E-mail Renovação</Label><Input type="email" className="form-control" id="email_renovacao-input" placeholder="E-mail para renovação" value={formData.email_renovacao} onChange={handleChange}/></div></Col>
                            </Row>

                            <h5 className="mb-3 mt-4">Endereço</h5>
                            <Row>
                                <Col lg={2}>
                                    <div className="mb-3">
                                        <Label className="form-label" htmlFor="pais-input">País*</Label>
                                        <Input
                                            name="pais"
                                            type="select"
                                            className="form-select"
                                            id="pais-input"
                                            value={pais}
                                            onChange={handleChange}
                                        >
                                            <option value="">Selecione...</option>
                                            {paises.map((item) => (
                                            <option key={item.id} value={item.sigla}>{item.nome}</option>
                                            ))}
                                        </Input>
                                    </div>
                                </Col>
                                {isBrasil && (
                                    <>
                                        <Col lg={2}><div className="mb-3"><Label className="form-label" htmlFor="cep-input">CEP</Label><Input type="text" className="form-control" id="cep-input" placeholder="Informe o CEP" value={formData.cep} onChange={handleChange} onBlur={(e) => buscarCep(e.target.value)} /></div></Col>
                                    </>
                                )}
                                        <Col lg={6}><div className="mb-3"><Label className="form-label" htmlFor="endereco-input">Endereço</Label><Input type="text" className="form-control" id="endereco-input" placeholder="Rua, Avenida, etc." value={formData.endereco} onChange={handleChange}/></div></Col>
                                        <Col lg={2}><div className="mb-3"><Label className="form-label" htmlFor="numero-input">Número</Label><Input type="text" className="form-control" id="numero-input" placeholder="Número" value={formData.numero} onChange={handleChange}/></div></Col>
                                   
                            </Row>
                            
                                <Row>
                                    <Col lg={3}><div className="mb-3"><Label className="form-label" htmlFor="complemento-input">Complemento</Label><Input type="text" className="form-control" id="complemento-input" placeholder="Complemento (opcional)" value={formData.complemento} onChange={handleChange}/></div></Col>
                                    <Col lg={3}><div className="mb-3"><Label className="form-label" htmlFor="bairro-input">Bairro</Label><Input type="text" className="form-control" id="bairro-input" placeholder="Bairro" value={formData.bairro} onChange={handleChange}/></div></Col>
                                    <Col lg={3}><div className="mb-3"><Label className="form-label" htmlFor="cidade-input">Cidade</Label><Input type="text" className="form-control" id="cidade-input" placeholder="Cidade" value={formData.cidade} onChange={handleChange}/></div></Col>
                                    <Col lg={3}><div className="mb-3"><Label className="form-label" htmlFor="estado-input">Estado</Label><Input type="text" className="form-control" id="estado-input" placeholder="Estado" value={formData.estado} onChange={handleChange}/></div></Col>
                                </Row>
                            
                            <h5 className="mb-3 mt-4">Redes Sociais</h5>
                            <Row>
                                <Col lg={3}><div className="mb-3"><Label className="form-label" htmlFor="youtube-input">Youtube</Label><Input type="text" className="form-control" id="youtube-input" placeholder="Informe o youtube" value={formData.youtube} onChange={handleChange}/></div></Col>
                                <Col lg={3}><div className="mb-3"><Label className="form-label" htmlFor="instagram-input">Instagram</Label><Input type="text" className="form-control" id="instagram-input" placeholder="Informe o instagram" value={formData.instagram} onChange={handleChange}/></div></Col>
                                <Col lg={3}><div className="mb-3"><Label className="form-label" htmlFor="facebook-input">Facebook</Label><Input type="text" className="form-control" id="facebook-input" placeholder="Informe o facebook" value={formData.facebook} onChange={handleChange}/></div></Col>
                                <Col lg={3}><div className="mb-3"><Label className="form-label" htmlFor="linkedin-input">LinkedIn</Label><Input type="text" className="form-control" id="linkedin-input" placeholder="Informe o LinkedIn" value={formData.linkedin} onChange={handleChange}/></div></Col>
                                <Col lg={3}><div className="mb-3"><Label className="form-label" htmlFor="twitter-input">Twitter</Label><Input type="text" className="form-control" id="twitter-input" placeholder="Informe o twitter" value={formData.twitter} onChange={handleChange}/></div></Col>
                                <Col lg={3}><div className="mb-3"><Label className="form-label" htmlFor="bluesky-input">Site</Label><Input type="text" className="form-control" id="bluesky-input" placeholder="Informe o site" value={formData.bluesky} onChange={handleChange}/></div></Col>
                            </Row>

                            {/* --- NOVA SEÇÃO DE IMAGENS --- */}
                            <h5 className="mb-3 mt-4">Imagens da Galeria</h5>
                            <Row>
                                <Col>
                                    <div className="mb-3">
                                        <Label className="form-label">Adicionar Imagens</Label>
                                        <Input
                                            type="file"
                                            multiple
                                            accept="image/*"
                                            onChange={handleImagensChange}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="d-flex flex-wrap" style={{gap: "1rem"}}>
                                        {formData.imagens.map((img, index) => (
                                            <div key={index} style={{ position: "relative" }}>
                                                <img
                                                    src={img.preview || img.url}
                                                    alt={`Imagem ${index + 1}`}
                                                    style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "8px" }}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => removeImagemProduto(index)}
                                                    style={{ position: "absolute", top: "-8px", right: "-8px", background: "#ff4444", color: "white", border: "none", borderRadius: "50%", cursor: "pointer", width: "24px", height: "24px", display: "flex", alignItems: "center", justifyContent: "center" }}
                                                >
                                                    <i className="ri-close-line" />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </Col>
                            </Row>

                            {/* --- NOVA SEÇÃO DE SEGMENTAÇÃO --- */}
                            <h5 className="mb-3 mt-4">Segmentação</h5>
                            <Row>
                                <Col lg={4}>
                                    <div className="mb-3">
                                        <Label className="form-label">Setor</Label>
                                        <Select 
                                            value={selectedSetores} 
                                            isMulti 
                                            styles={{
                                                multiValueLabel: (styles) => ({
                                                    ...styles,
                                                    color: 'white', // Cor do texto do label
                                                    fontWeight: 'bold',         // Outras opções de estilo
                                                }),
                                                multiValue: (styles) => ({
                                                    ...styles,
                                                    backgroundColor: '#1a73e8', // Cor do chip como um todo (opcional)
                                                }),
                                                }}
                                            onChange={setSelectedSetores} 
                                            options={setoresOpcoes}
                                            placeholder="Selecione..."/>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="mb-3">
                                        <Label className="form-label">Categoria</Label>
                                        <Select styles={{
                          multiValueLabel: (styles) => ({
                            ...styles,
                            color: 'white', // Cor do texto do label
                            fontWeight: 'bold',         // Outras opções de estilo
                          }),
                          multiValue: (styles) => ({
                            ...styles,
                            backgroundColor: '#1a73e8', // Cor do chip como um todo (opcional)
                          }),
                        }}
                        value={selectedCategorias} isMulti onChange={setSelectedCategorias} options={categoriasOpcoes} placeholder="Selecione..."/>
                                    </div>
                                </Col>
                            
                            </Row>

                            <h5 className="mb-3 mt-4">Status</h5>
                            <Row>
                                <Col lg={6}>
                                    <div className="mb-3">
                                        <li className="d-flex">
                                            <div className="flex-shrink-0"><div className="form-check form-switch form-switch-lg"><Input className="form-check-input" type="checkbox" role="switch" id="ativo" checked={ativo} onChange={(e) => setAtivo(e.target.checked)}/></div></div>
                                            <div className="flex-grow-1"><label htmlFor="ativo" className="form-check-label fs-14">Ativo</label><p className="text-muted">Expositor está ativo ou inativo</p></div>
                                        </li>
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div className="mb-3">
                                        <li className="d-flex">
                                            <div className="flex-shrink-0"><div className="form-check form-switch form-switch-lg"><Input className="form-check-input" type="checkbox" role="switch" id="aprovado" checked={aprovado} onChange={(e) => setAprovado(e.target.checked)}/></div></div>
                                            <div className="flex-grow-1"><label htmlFor="aprovado" className="form-check-label fs-14">Aprovado pelo comercial</label><p className="text-muted">Expositor aprovado pelo comercial</p></div>
                                        </li>
                                    </div>
                                </Col> 
                            </Row>

                            {isEditando && arquivosSalvos?.length > 0 && (
                                <Row className="mt-3">
                                    <Col>
                                    <h5 className="mb-3"><i className="ri-attachment-line align-bottom me-2"></i>Arquivos Anexados</h5>
                                    {/* ... (Tabela de arquivos inalterada) ... */}
                                    </Col>
                                </Row>
                            )}
                        </CardBody>
                        
                                               <CardFooter>
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                <button
                                    type="submit"
                                    className="btn btn-success w-sm"
                                    onClick={salvar}
                                >
                                    Salvar
                                </button>{" "}
                                <button
                                    onClick={() => setModalArquivos(true)}
                                    className="btn btn-soft-dark"
                                >
                                    <i className="ri-attachment-line align-middle me-1"></i>
                                    Enviar Arquivos
                                </button>{" "}
                                <div className="btn-group ms-2">
                                    <button    
                                    onClick={handleExportPDF}
                                    className="btn btn-soft-warning"
                                    >
                                    <i className="ri-file-pdf-line align-bottom me-1"></i> PDF
                                    </button>
                                    <button    
                                    onClick={handleExportCSV}
                                    className="btn btn-soft-success"
                                    >
                                    <i className="ri-file-excel-line align-bottom me-1"></i> CSV
                                    </button>
                                    <button    
                                    onClick={handleExportXML}
                                    className="btn btn-soft-primary"
                                    >
                                    <i className="ri-code-line align-bottom me-1"></i> XML
                                    </button>
                                </div>
                                </div>
                            </div>
                        </CardFooter>
                    </Card>
                </Col>
            </Row>

            <Modal isOpen={modalArquivos} toggle={() => setModalArquivos(!modalArquivos)} size="lg">
              <ModalHeader toggle={() => setModalArquivos(!modalArquivos)}>
                <i className="ri-file-upload-line me-2"></i>
                Enviar Arquivos
              </ModalHeader>
              <ModalBody>
                <Form>
                  <FormGroup>
                    <Label>Arquivos</Label>
                    <FileUploader
                    label="Arraste e solte arquivos aqui ou clique para selecionar"
                  hoverTitle="Solte aqui!"
                      multiple={true}
                      handleChange={(files) => setFiles(files)}
                      name="arquivos"
                      types={["JPG", "PNG", "PDF", "DOC", "DOCX", "XLS", "XLSX"]}
                    >
                      
                      </FileUploader>
                    <div className="mt-2">
                      {files.length > 0 && (
                        <div>
                          <h6>Arquivos selecionados:</h6>
                          <ul>
                            {Array.from(files).map((file, index) => (
                              <li key={index}>{file.name}</li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </FormGroup>
                  
                  <FormGroup>
                    <Label>Observação</Label>
                    <Input
                      type="textarea"
                      value={observacaoArquivos}
                      onChange={(e) => setObservacaoArquivos(e.target.value)}
                      placeholder="Informe uma observação sobre os arquivos (opcional)"
                      rows="3"
                    />
                  </FormGroup>
                </Form>
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={() => setModalArquivos(false)} disabled={loadingArquivos}>
                  Cancelar
                </Button>
                <Button 
                  color="primary" 
                  onClick={handleEnviarArquivos} 
                  disabled={loadingArquivos || files.length === 0}
                >
                  {loadingArquivos ? 'Enviando...' : 'Enviar Arquivos'}
                </Button>
              </ModalFooter>
            </Modal>

            <Modal isOpen={modalDelete} toggle={toggleModalDelete} centered>
                <div className="modal-header">
                <h5 className="modal-title">Confirmar exclusão</h5>
                <button
                    type="button"
                    className="btn-close"
                    onClick={() => setModalDelete(false)}
                ></button>
                </div>
                <div className="modal-body text-center">
                <p className="fs-15">
                    Tem certeza que deseja excluir?
                </p>
                </div>
                <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={toggleModalDelete}
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => { handleExcluirArquivo(arquivoExcluir)} }>
                    Confirmar
                </button>
                </div>
            </Modal>

        </React.Fragment>
    );
};

export default CadastroExpositor;